'use client';

import { useEffect } from 'react';

interface Props {
    error: Error & { digest?: string };
    reset: () => void;
}

export default function Error({ error, reset }: Props) {
    useEffect(() => {
        fetch('/api/log-error', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: 'route_error',
                message: error.message || 'Unknown error',
                stack: error.stack || '',
                digest: error.digest || '',
                url: typeof window !== 'undefined' ? window.location.href : '',
                userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
                timestamp: new Date().toISOString(),
            }),
        }).catch(() => {});
    }, [error]);

    return (
        <div style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'Arial, sans-serif',
        }}>
            <div style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '2.5rem',
                maxWidth: '500px',
                width: '100%',
                boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                border: '1px solid #e5e7eb',
            }}>
                <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
                <h2 style={{ color: '#dc2626', marginBottom: '0.5rem', fontSize: '1.25rem' }}>
                    حدث خطأ
                </h2>
                <p style={{ color: '#6b7280', marginBottom: '1.5rem', lineHeight: 1.6 }}>
                    تعذّر تحميل هذه الصفحة. تم تسجيل المشكلة.
                </p>

                {process.env.NODE_ENV !== 'production' && (
                    <details style={{
                        textAlign: 'left',
                        background: '#fef2f2',
                        border: '1px solid #fca5a5',
                        borderRadius: '8px',
                        padding: '1rem',
                        marginBottom: '1.5rem',
                        fontSize: '0.8rem',
                        color: '#7f1d1d',
                    }}>
                        <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                            تفاصيل الخطأ (dev only)
                        </summary>
                        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0 }}>
                            {error.message}
                            {'\n\n'}
                            {error.stack}
                        </pre>
                    </details>
                )}

                {error.digest && (
                    <p style={{ color: '#9ca3af', fontSize: '0.75rem', marginBottom: '1.5rem' }}>
                        كود الخطأ: <code style={{ background: '#f3f4f6', padding: '2px 6px', borderRadius: '4px' }}>{error.digest}</code>
                    </p>
                )}

                <button
                    onClick={reset}
                    style={{
                        background: '#2563eb',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '0.75rem 2rem',
                        fontSize: '1rem',
                        cursor: 'pointer',
                    }}
                >
                    إعادة المحاولة
                </button>
            </div>
        </div>
    );
}
